import React from 'react'

import { HStack } from '~/components/elements/HStack'

import { type DocumentImage } from '../hooks/useFetchArchivedDocumentImages'

import { DeleteButton } from './DeleteButton'
import { UnarchiveButton } from './UnarchiveButton'

export type CommandsCellProps = {
  dataItem: DocumentImage
}

export const CommandsCell = ({
  dataItem: documentImage,
}: CommandsCellProps) => (
  <td>
    <HStack backgroundColor="transparent" spacing={1}>
      <UnarchiveButton documentImage={documentImage} />

      <DeleteButton documentImage={documentImage} />
    </HStack>
  </td>
)
